import React, { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

export default function TableSorter(props) {
  const [thisColumnStateIfClicked, setthisColumnStateIfClicked] = useState("name_asc");
  const [thisColumnState, setthisColumnState] = useState(null);
  const [noSort, setnoSort] = useState(false);

  useEffect(() => {
    updateColumnState(props.name, props.currentOrderBy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.currentOrderBy, props.name]); 

  const thisColumnNameToAsc = (col) => {
    const raw = String(col || "").trim();
    if (!raw) return null;

    const c = raw.toUpperCase();
    if (c === "STIM ID" || c === "STUDY ID") return "id_asc";
    if (c === "NAME") return "name_asc";
    if (c === "UPLOAD DATE") return "created_asc";

    return `${raw}_asc`;
  };

  const thisColumnNameToDesc = (col) => {
    const raw = String(col || "").trim();
    if (!raw) return null;

    const c = raw.toUpperCase();
    if (c === "STIM ID" || c === "STUDY ID") return "id_desc";
    if (c === "NAME") return "name_desc";
    if (c === "UPLOAD DATE") return "created_desc";

    // fallback for cache page keys
    return `${raw}_desc`;
  };

  const updateColumnState = (thisColumnName, columnCurrentlySelected) => {
    const canAsc = !!thisColumnNameToAsc(thisColumnName);
    const canDesc = !!thisColumnNameToDesc(thisColumnName);
    setnoSort(!(canAsc && canDesc));

    const asc = thisColumnNameToAsc(thisColumnName);
    const desc = thisColumnNameToDesc(thisColumnName);

    if (!asc || !desc) {
      setthisColumnState(null);
      setthisColumnStateIfClicked("name_asc");
      return;
    }

    if (columnCurrentlySelected === asc) {
      setthisColumnState("asc");
      setthisColumnStateIfClicked(desc);
      return;
    }

    if (columnCurrentlySelected === desc) {
      setthisColumnState("desc");
      setthisColumnStateIfClicked(asc);
      return;
    }

    setthisColumnState(null);
    setthisColumnStateIfClicked(asc);
  };

  return (
    <div style={{ display: "inline-flex", alignItems: "center" }}>
      {noSort ? null : (
        <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
          {/* asc */}
          <IconButton
            size="small"
            style={{ padding: 2 }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const next = thisColumnNameToAsc(props.name);
              if (next) props.handleSortChange(next);
            }}
          >
            <ArrowUpwardIcon
              fontSize="small"
              style={{ opacity: thisColumnState === "asc" ? 1 : 0.3 }}
            />
          </IconButton>

          {/* desc */}
          <IconButton
            size="small"
            style={{ padding: 2, marginTop: -6 }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const next = thisColumnNameToDesc(props.name);
              if (next) props.handleSortChange(next);
            }}
          >
            <ArrowDownwardIcon
              fontSize="small"
              style={{ opacity: thisColumnState === "desc" ? 1 : 0.3 }}
            />
          </IconButton>
        </div>
      )}
    </div>
  );
}